'use client';

import { cn } from '@noirproperties/ui/lib/utils';

type ImageOverlayProps = {
  slots: {
    visible: React.ReactNode;
  };
  children?: React.ReactNode;
  className?: string;
};

export function ImageOverlay({
  slots,
  children,
  className,
}: ImageOverlayProps) {
  return (
    <section
      className={cn(
        `relative isolate h-svh w-full overflow-hidden pt-48
        before:absolute before:inset-0 before:z-20 before:h-40 before:w-full before:bg-gradient-to-b before:from-neutral-900/90 `,
        className,
      )}
      id="image-overlay"
    >
      <div className="z-30 mx-auto max-w-7xl">
        <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-xl">
          {slots.visible}

          {children}
        </div>
      </div>
    </section>
  );
}
